import { useTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import { H2 } from "src/atoms/typography";
import NoiseIndicator from "src/modules/station/components/NoiseIndicator";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";
import { BarkioOnly, BibinoOnly } from "src/utils/environment";
import { Activities } from "src/modules/activity-log/activity";
import BabyLottieAnimation from "src/modules/avatar/components/BabyLottieAnimation";
import DogAvatar from "src/modules/avatar/components/DogAvatar";
import SvgContainer from "src/components/SvgContainer";
import { DeviceName } from "src/modules/device/components/DeviceSpec";
import AnimationBox from "../../components/AnimationBox";
import { ReactComponent as awakeDetachIcon } from "./detach-awake-baby.svg";
import { AvatarModes } from "src/modules/avatar/enum";
import { AvatarProfile } from "../../components/AvatarContainers";

export default function Awake({
  showSmallAvatar,
  selectedAvatar,
  isInDetachMode,
  isInTileView,
  isMultiRoom,
  avatarSize,
  noiseMeter,
  jid
}) {
  const { t } = useTranslation();
  const displayProfileImage =
    selectedAvatar && selectedAvatar.previewMode === AvatarModes.profileImage && selectedAvatar.profileImageFile;
  return (
    <Flex
      width="100%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      {...(!isInDetachMode && { flex: "1 1 auto" })}
    >
      <Box
        sx={{
          "@media (max-height: 140px)": {
            display: "none"
          }
        }}
      >
        {showSmallAvatar && <CorrespondingAvatar width={avatarSize} height={avatarSize} avatar={selectedAvatar} />}

        {!showSmallAvatar && displayProfileImage && <AvatarProfile avatar={selectedAvatar} />}

        {!showSmallAvatar && !displayProfileImage && (
          <AnimationBox mb={isInDetachMode ? "4px" : "0px"}>
            <BibinoOnly
              browserProps={{ useTheme: false }}
              sex={selectedAvatar?.sex}
              {...selectedAvatar?.avatarCustomization}
              skinColor={selectedAvatar?.avatarCustomization?.skinColor || selectedAvatar?.moreDataJson?.skinColor}
              animationName="awake.json"
            >
              {BabyLottieAnimation}
            </BibinoOnly>
            <BarkioOnly
              browserProps={{ useTheme: false }}
              imageName={`light-noisy-${selectedAvatar?.avatarCustomization?.breedAppearance || "default"}.svg`}
            >
              {DogAvatar}
            </BarkioOnly>
          </AnimationBox>
        )}
      </Box>
      {isMultiRoom && <DeviceName deviceJid={jid} activity={Activities.AWAKE} />}
      <Box
        display="none"
        sx={{
          "@media (max-height: 140px)": {
            display: "inline-block"
          }
        }}
      >
        <SvgContainer mb="8px" icon={awakeDetachIcon} size="32px" fill="white" />
      </Box>
      <H2
        // fontSize={isInDetachMode ? "6.9vmin" : ["20px", "28px", "32px"]}
        fontSize={isInDetachMode ? "6.9vmin" : "clamp(2rem, 3.82vmin, 3.2rem)"}
        // lineHeight={isInDetachMode ? "8.7vmin" : ["24px", "32px", "40px"]}
        letterSpacing={["0.24px", "0.34px", "0.38px"]}
        color="white"
        mt={isInDetachMode ? "8px" : "16px"}
        mb={isInDetachMode ? "2.5vmin" : "16px"}
        {...(isInDetachMode && {
          sx: {
            "@media (max-height: 140px)": {
              fontSize: "10px !important",
              lineHeight: "1.1 !important",
              mt: "0px !important"
            }
          }
        })}
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        maxWidth={isInDetachMode ? "90vw" : isInTileView ? "calc(100% + 102px)" : "60vw"}
      >
        {selectedAvatar
          ? t(selectedAvatar.sex === "male" ? "maleIsAwake" : "femaleIsAwake", {
              value0: selectedAvatar.name
            })
          : t("avatarIsAwake")}
      </H2>
      {noiseMeter && (
        <NoiseIndicator mode="audio" station={"parent"} noiseMeter={noiseMeter} colorFirstTwoDots={false} />
      )}
    </Flex>
  );
}
